import React, {useState} from "react";
import {
    AppBar,
    Button,
    Card,
    CardContent,
    CircularProgress,
    TextField,
    Toolbar,
    Typography,
    useMediaQuery
} from "@material-ui/core";
import AppIcon from "../views/AppIcon";
import {useWindowSize} from "react-use";
import {useTheme} from '@material-ui/core/styles';
import {PasswordRecoveryState} from "../enums/AuthState";
import {useWelcomeStyle} from "../styles/WelcomeStyle";
import MaterialSnackBar from "../views/MaterialSnackBar";
import {Validator} from '../utils/Validator';
import AppColors from "../colors/AppColors";
import {useOnBoarderStyle} from "../styles/OnBoarderSlideStyles";
import Strings from "../lang/Strings";
import axios from "axios";
import EndPoints from "../net/EndPoints";
import MuiAlert from '@material-ui/lab/Alert';

export default function ForgotPasswordView() {

    const welcomeClasses = useWelcomeStyle();
    const onBoarderClasses = useOnBoarderStyle();

    const {width, height} = useWindowSize();
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down(800));
    const [passwordRecoveryState, setPasswordRecoveryState] = useState(PasswordRecoveryState.IDLE);
    const [email, setEmail] = useState<string | null>("");
    const [recoveryEmailSent, setRecoveryEmailSent] = useState(false);
    const [recoveryEmailFeedBack, setRecoveryEmailFeedBack] = useState("");

    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("warning");

    const handleSnackClose = () => {
        setOpenSnack(false);
    }

    const snackError = (message: string) => {
        setSnackMessage(message);
        setSnackSeverity("error");
        setOpenSnack(true);
    }

    const handleEmailChange = (newValue: string | null) => {
        setEmail(newValue);
    }

    const handleKeyEvent = (event: KeyboardEvent) => {
        if (event.keyCode === 13) {
            attemptPasswordRecovery();
        }
    }

    const attemptPasswordRecovery = () => {
        if (email?.length === 0) {
            snackError("Please enter your registered email address");
        } else {
            if (!Validator.isEmailValid(email as string)) {
                snackError("Invalid Email Address provided");
            } else {
                setRecoveryEmailSent(false);
                setPasswordRecoveryState(PasswordRecoveryState.STARTED);
                let postData = {
                    email: email!!
                }
                axios.post(EndPoints.PASSWORD_RECOVERY, postData).then(data => {
                    let message = data["data"]["message"];
                    setRecoveryEmailFeedBack(message);
                    setRecoveryEmailSent(true);
                    setPasswordRecoveryState(PasswordRecoveryState.STOPPED);
                }).catch(error => {
                    let errorResponseData = error.response ? error.response["data"] : {};
                    let message = errorResponseData["message"] ?? "Error completing password recovery. Please try again";
                    setPasswordRecoveryState(PasswordRecoveryState.STOPPED);
                    snackError(message);
                });
            }
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                background: `url(${require('./../images/wallet_background.png')})`,
                backgroundColor: '#121d33e1',
                backgroundRepeat: 'none',
                backgroundSize: 'cover'
            }}>
            <AppBar position="static"
                    elevation={0}
                    style={{
                        background: 'none'
                    }}>
                <Toolbar>
                    <AppIcon/>
                </Toolbar>
            </AppBar>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: height
            }}>
                <Card
                    style={{
                        width: mobileView ? width - 30 : width / 2,
                        borderRadius: 10,
                    }}>
                    <CardContent
                        style={{
                            margin: 30
                        }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                            <Typography
                                style={{
                                    fontWeight: 600,
                                    alignSelf: 'flex-start',
                                    fontSize: 20
                                }}>Forgot Your Password?</Typography>
                            {
                                recoveryEmailSent &&
                                <MuiAlert severity="success">{recoveryEmailFeedBack}</MuiAlert>
                            }
                            <TextField
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                disabled={passwordRecoveryState === PasswordRecoveryState.STARTED}
                                id="email"
                                label="Email Address"
                                name="email"
                                value={email}
                                placeholder={"Enter your registered email address"}
                                onChange={(event) => {
                                    handleEmailChange(event.target.value)
                                }}
                                onKeyDown={(event) => {
                                    handleKeyEvent(event as unknown as KeyboardEvent)
                                }}
                                autoComplete="email"
                                className={welcomeClasses.fullScreenAuthFields}
                                style={{
                                    marginTop: 30,
                                    fontWeight: 600,
                                }}
                            />
                            {

                            }
                            <Button onClick={attemptPasswordRecovery}
                                    className={mobileView ? onBoarderClasses.getStartedButtonSmall : onBoarderClasses.getStartedButton}
                                    style={{
                                        width: '100%',
                                        marginTop: 10,
                                        fontSize: mobileView ? 13 : 20,
                                    }}
                                    disabled={email?.length === 0 || passwordRecoveryState === PasswordRecoveryState.STARTED}>{passwordRecoveryState === PasswordRecoveryState.STARTED ? Strings.PLEASE_WAIT : Strings.RECOVER_PASSWORD}
                                {
                                    passwordRecoveryState === PasswordRecoveryState.STARTED &&
                                    <CircularProgress color="inherit" size={20}
                                                      style={{
                                                          marginLeft: 10,
                                                          color: AppColors.ACCENT_COLOR
                                                      }}/>
                                }
                            </Button>
                        </div>
                    </CardContent>
                </Card>
            </div>
            <MaterialSnackBar open={openSnack} onSnackClosed={handleSnackClose} message={snackMessage}
                              severity={snackSeverity}/>
        </div>
    );
}